<template>
  <div class="pb-page ab">
    <PageHeader title="Brand moderation" subtitle="Find a brand and pause its public pages. Its workspace keeps every piece of feedback and can still export it." />
    <form class="ab-search" role="search" @submit.prevent="load">
      <label class="pb-sr-only" for="ab-q">Search brands</label>
      <input id="ab-q" v-model="q" class="pb-input" type="search" placeholder="Brand name or wall address" maxlength="120">
      <button type="submit" class="pb-button">Search</button>
    </form>
    <div v-if="error" class="pb-alert is-error" role="alert"><span>{{ error }}</span></div>
    <div class="pb-card ab-card">
      <table class="ab-table">
        <thead><tr><th scope="col">Brand</th><th scope="col">Owner</th><th scope="col">Published</th><th scope="col">Open removals</th><th scope="col">Spam</th><th scope="col">Status</th><th scope="col"><span class="pb-sr-only">Actions</span></th></tr></thead>
        <tbody>
          <tr v-for="row in rows" :key="row.id">
            <th scope="row"><a :href="row.wall_url" target="_blank" rel="noopener">{{ row.name }}</a><span class="pb-muted ab-slug">/w/{{ row.slug }}</span></th>
            <td>{{ row.owner_email }}</td><td>{{ row.published }}</td><td>{{ row.open_removals }}</td><td>{{ row.spam }}</td>
            <td><span v-if="row.admin_paused" class="pb-chip spam">Paused</span><span v-else class="pb-chip approved">Serving</span>
              <span v-if="row.admin_reason" class="pb-muted ab-reason">{{ row.admin_reason }}</span></td>
            <td><button v-if="!row.admin_paused" type="button" class="pb-button sm danger" @click="pause(row)">Pause</button>
              <button v-else type="button" class="pb-button sm outline" @click="unpause(row)">Resume</button></td>
          </tr>
          <tr v-if="!rows.length && !loading"><td colspan="7" class="pb-muted">No brands match.</td></tr>
        </tbody>
      </table>
    </div>
    <v-dialog v-model="pauseOpen" max-width="480">
      <form class="pb-dialog" @submit.prevent="confirmPause">
        <h2>Pause {{ target ? target.name : '' }}?</h2>
        <p>Its widgets, wall and collection pages stop serving. The owner sees the reason.</p>
        <div class="pb-field"><label class="pb-label" for="ab-reason">Reason</label>
          <textarea id="ab-reason" v-model="reason" class="pb-textarea" rows="3" maxlength="300" required></textarea></div>
        <div class="pb-dialog-actions"><button type="button" class="pb-button ghost" @click="pauseOpen = false">Cancel</button>
          <button type="submit" class="pb-button danger" :disabled="!reason.trim()">Pause brand</button></div>
      </form>
    </v-dialog>
  </div>
</template>

<script>
import PageHeader from '../components/PageHeader.vue';
import { get, post, message } from '../api';
import { toast } from '../lib/toast';

export default {
  name: 'AdminBrandsView',
  components: { PageHeader },
  data: () => ({ q: '', rows: [], loading: false, error: '', pauseOpen: false, target: null, reason: '' }),
  mounted() { this.load(); },
  methods: {
    async load() {
      this.loading = true;
      this.error = '';
      try { this.rows = (await get('/admin/brands', { q: this.q.trim() })).brands || []; } catch (error) { this.error = message(error); } finally { this.loading = false; }
    },
    pause(row) { this.target = row; this.reason = ''; this.pauseOpen = true; },
    async confirmPause() {
      try {
        await post('/admin/brands/' + this.target.id + '/pause', { paused: true, reason: this.reason.trim() });
        this.pauseOpen = false;
        toast(this.target.name + ' is paused.');
        this.load();
      } catch (error) { toast(message(error), 'error'); }
    },
    async unpause(row) {
      try { await post('/admin/brands/' + row.id + '/pause', { paused: false }); toast(row.name + ' is serving again.'); this.load(); } catch (error) { toast(message(error), 'error'); }
    }
  }
};
</script>

<style scoped>
.ab-search{display:flex;gap:10px;margin-bottom:16px}
.ab-search .pb-input{flex:1}
.ab-card{padding:0;overflow-x:auto}
.ab-table{width:100%;border-collapse:collapse;font-size:14px}
.ab-table th,.ab-table td{padding:12px 16px;text-align:left;border-bottom:1px solid #EFE9E0;vertical-align:top}
.ab-table thead th{background:#FBF8F3;font:600 12.5px var(--font-body);color:#4F4A45}
.ab-table tbody th a{color:#1F2328;font-weight:600}
.ab-slug,.ab-reason{display:block;margin-top:2px}
</style>
